var $1c5e8019b2316336$exports = {};
$1c5e8019b2316336$exports = {
    "valid": `\u{5EA}\u{5B8}\u{5E7}\u{5B5}\u{5E3}`
};


export {$1c5e8019b2316336$exports as default};
//# sourceMappingURL=he-IL.module.js.map
